<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
import CarroselEcards from 'components/Ecards/CarroselEcards.vue'
import BannerAssineHorizontal from 'components/HomePage/BannerAssineHorizontal.vue'
import AllEcardsPagination from 'components/Ecards/AllEcardsPagination.vue'
import ModalEcards from '../../components/Modais/ModalEcards.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body">
      <div class="block--gray">
        <div class="container">
          <div class="row pt-3 pb-5">
            <div class="col-lg-2 pt-3">
              <h1 class="title">{{ translate.title }}</h1>
            </div>
            <div class="col-lg-8 pt-3 d-flex align-items-center">
              <span class="subtitle1">{{ translate.subTitle1 }}</span>
              <span class="subtitle2">&nbsp;{{ translate.subTitle2 }}</span>
            </div>
          </div>
        </div>
        <div class="pb-5">
          <div class="col-lg-12">
            <CarroselEcards @showModalEcard="showModalEcard" :posts="posts" />
          </div>
        </div>
      </div>
      <div class="container">
        <AllEcardsPagination v-if="showPaginate" @showModalEcard="showModalEcard" :models="models" />
      </div>
      <div class="py-5">
        <BannerAssineHorizontal :path="bannerAssineHorizontal" />
      </div>
    </div>
    <ModalEcards @showModalEcard="showModalEcard" :show="show" :model="model" :styleClass="styleClass" />
  </MainLayout>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import ContactTradutor from 'tradutors/ecards'
import api from '../../api'
import { isMobile } from "../shared/utils/mobile";

export default defineComponent({
  name: 'ContactUsView',
  computed: {
    ...mapState(localeStore, ['locale']),
    translate: function () {
      if (this.locale === 'pt-br') {
        return ContactTradutor.portugues
      } else {
        return ContactTradutor.ingles
      }
    }
  },
  watch: {
    'locale': function () {
      this.getBannerAssineHorizontal(true)
    }
  },
  head() {
    return {
      templateParams: {
        subTitle: null, 
        subPage: this.translate.title,
        page_url: window.location.origin + this.$route.fullPath,
        page_description: this.locale == 'pt-br' ?
          `Aniversário daquele amigo especial? Envie um eCard do Bella da Semana!` :
          `That special friend\'s birthday? Send a Bella Club eCard!`,
        page_image: '/favicon.ico',
        page_keywords: 'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: this.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br/ecards",
        page_url_en: "https://belladasemana.com.br/en/ecards",
        page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,        
      }
    }
  },
  data() {
    return {
      posts: {},
      models: {},
      showPaginate: false,
      bannerAssineHorizontal: [],
      show: false,
      model: null,
      styleClass: '',
      isMobile: isMobile(),      
    }
  },
  created() {
    const lang = ['pt-br', 'en']
    if (lang.indexOf(this.$route.params.locale) === -1) {
      window.location.replace('/')
    }
    this.getModels()
    this.getLastModels()
    this.getBannerAssineHorizontal()
  },
  methods: {
    showModalEcard(value, model = null, style = 'vertical-w') {
      this.show = value
      this.model = model
      this.styleClass = style
    },
    async getModels() {
      api.get('v1/ecards/getAllEcards').then(({ data }) => {
        this.models = data.modelsArray
        this.showPaginate = true
      })
    },
    async getLastModels() {
      api.get('v1/ecards/getLastFiveEcards').then(({ data }) => {
        this.posts = data.postsCarroselModels
      })
    },
    async getBannerAssineHorizontal(changeLanguage = false) {
      if (!sessionStorage.getItem("bannerAssineHorizontal") || changeLanguage)
      api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
        this.bannerAssineHorizontal = data.bannerAssineHorizontal
        sessionStorage.setItem(
            "bannerAssineHorizontal",
            JSON.stringify(this.bannerAssineHorizontal)
          );
      })
      else
        this.bannerAssineHorizontal = JSON.parse(
          sessionStorage.getItem("bannerAssineHorizontal")
        );
    }
  }
})
</script>

<style lang="css" scoped>
.slot-body {
  margin-top: 65px !important;  
  background-color: #fff !important;
}

.title {
  font-family: 'Bebas-Neue-Light';
  height: 77px;
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;  
}

.subtitle1, .subtitle2 {
  height: 28px;
  color: #5b5858;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.horizontal-h {
  height: 100%;
  max-height: 246px;
}

.vertical-h {
  height: 100%;
  max-height: 365px;
  object-fit: cover;
}

.horizontal-w {
  width: 100%;
  max-width: 335px;
}

.vertical-w {
  width: 100%;
  max-width: 241px;
  object-fit: cover;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .subtitle1 {
    color: #b20000;
  }

  .subtitle2 {
    display: none;
  }

}
</style>
